<template>
  <div class="">
    <van-empty description="什么都没有~" v-show="isEmpty" />
    <van-list style="margin-top: -5px" v-model="loading" :finished="finished" :finished-text="finishText" @load="onLoad" :immediate-check="false" :error.sync="error" error-text="请求失败，点击重新加载" :offset="30">
      <div class="pageList">
        <transition-group v-bind:css="false" v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:after-enter="afterEnter">
          <div class="padding15 pageListItem flexNone" v-for="(item, index) in dataList" :key="item.id" :data-delay="index * 20" data-y="100%" @click="handleRecDeatails(item.activityId)">
            <div class="hasInfo">
              <div class="actPicture">
                <van-image fit="cover" :src="item.photoUrl" />
              </div>
              <div class="actText">
                <van-row type="flex" justify="space-between" class="colorBlack">
                  <van-col span="24" class="van-ellipsis fz16 textBold marginBottom3">{{ item.activityName }}</van-col>
                </van-row>
                <van-row type="flex" justify="space-between" class="marginTop3 colorGrey1">
                  <!-- <van-col span="24" class="van-ellipsis">开放时间：{{ item.businessHours }}</van-col> -->
                  <!-- 是否长期(1是 2否) -->
              <van-col span="24" class="van-ellipsis" v-if='item.isLongTerm==2'>活动时间：{{item.activityStartTime}} - {{item.activityEndTime}}</van-col>
              <van-col span="24" class="van-ellipsis" v-if='item.isLongTerm==1'>长期</van-col>
                </van-row>
                <van-row type="flex" justify="space-between" class="marginTop3 colorGrey1 address">
                  <van-col span="24" class="van-ellipsis2">地址：{{ item.address }}</van-col>
                </van-row>
                <van-row type="flex" justify="space-between" class="marginTop12 points pointsConsume">
                  <van-col span="24" class="van-ellipsis">
                    <i class="iconfont icon-jifen marginRight5" style="color:#ccc" />
                    <span v-if='item.isConsume==1'>消耗虚拟资产:
                      <span class="num">{{minConsumeMoney(item.consumeTypeList)}}</span>元
                    </span>
                    <span v-if='item.isConsume==2'>免费</span>
                  </van-col>
                </van-row>
                <van-row type="flex" justify="space-between" class="marginTop3 points">
                  <van-col span="24" class="van-ellipsis">
                    <i class="iconfont icon-jifen marginRight5" style="color: #ccc" />奖励积分:
                    <span class="num">{{ item.signUpIntegral }}</span>分
                  </van-col>
                </van-row>
              </div>
            </div>

            <div class="mySignCon">
              <div class="fz12">
                报名时间：<span class="textBold">{{ item.createTime }}</span>
              </div>
              <div class="fz12 marginTop3" >
                审核时间：<span class="textBold">{{ item.examineTime }}</span>
              </div>
              <van-button class="signStateBtn" type="primary" :color="item.validFlag==3?'#d7263c':item.validFlag==2?'#07c160':'#ed6a0c'" round size='small'>{{item.validFlag==3?'未通过审核':item.validFlag==2?'已通过审核':'待审核'}}</van-button>
            </div>
          </div>
        </transition-group>
      </div>
    </van-list>
  </div>
</template>

<script>
import { mySignUp } from '@/api/data'
export default {
  data() {
    return {
      dataList: [],
      pageInfo: {
        page: 1,
        limit: 10,
      },
      loading: false,
      error: false,
      finished: false,
      finishText: '',
      isEmpty: false,
    }
  },
  created() {
    this.$toast.loading({
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner',
    });
    this.getList()
  },

  methods: {
    minConsumeMoney(list) {
      if (!list) { return 0 }
      return Math.max.apply(Math, list.map(item => { return item.money }))
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    beforeEnter(dom) {
      let { x = 0, y = 0, s = 1, opacity = 0 } = dom.dataset
      dom.style.cssText = `transition: .2s;opacity: ${opacity};transform: scale(${s}) translateX(${x}) translateY(${y});`
    },
    enter(dom, done) {
      let delay = dom.dataset.delay
      setTimeout(function () {
        dom.style.cssText = `transition: .2s;opacity: 1;transform: scale(1) translateX(0) translateY(0);`
        //监听 transitionend 事件
        var transitionend = window.ontransitionend
          ? 'transitionend'
          : 'webkitTransitionEnd'
        dom.addEventListener(transitionend, function onEnd() {
          dom.removeEventListener(transitionend, onEnd)
          done() //调用done() 告诉vue动画已完成，以触发 afterEnter 钩子
        })
      }, delay)
    },
    afterEnter(dom) {
      dom.style.cssText = ''
    },

    getList(type) {
      let _this = this
      let obj = Object.assign({}, _this.pageInfo,{status:2}) //1.进行中 2.已完成 3.未开始
      mySignUp(obj)
        .then((res) => {
          if (res) {
            if (res.data.totalCount == 0) {
              _this.isEmpty = true
            } else {
              _this.isEmpty = false
            }
            if (!res.data.list) {
              _this.finished = true
              return
            }
            if (type == 'reset') {
              _this.dataList = []
              _this.finishText = ''
            }
            setTimeout(() => {
              _this.dataList.push(...res.data.list)
              _this.loading = false
              if (res.data.currPage === res.data.totalPage &&res.data.totalCount>0) {
                _this.finished = true
                _this.finishText = '亲，已经到底啦'
                return
              }
            }, 300)
          } else {
            _this.isEmpty = true
             _this.dataList = []
            _this.finishText=''
          }
          _this.$toast.clear()
        })
        .catch(() => {
          _this.$toast.clear()
        })
    },
    onLoad() {
      this.pageInfo.page++
      this.getList()
    },
    handleRecDeatails(id) {
      this.$router.push({ name: 'actDetail', query: { id: id } })
    },

  },
}
</script>

<style lang='less'>
.mySignCon {
    
  margin-top: 15px;
  padding: 8px 10px;
  border-radius: 12px;
  background: #f5f5f5;
  position: relative;
  .signStateBtn{position: absolute;right: 10px;top: 10px;}
  .text {
    line-height: 32px;
  }
}
</style>